

import EnhancedDashboard from './_components/Main-View';

export default function Dashboard() {
  return (
    <div>
      <EnhancedDashboard />
    </div>
  );
}
